<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button 
          v-if="!isResourceViewActive && !isBackButtonHidden"
          style="border-radius: 15px"
          @click="backToSelect"
          icon-pack="feather"
          icon="icon-arrow-left"
          class="float-left mb-3 school-primary_gradient glow-effect_primary">
          Back
        </vs-button> 
      </div>
    </div> 
    <div class="vx-row pb-3" v-show="isResourceViewActive">
      <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
        <vx-card class="overlay-card overflow-hidden library-content-cards" @click="showBooks">
          <template slot="no-body">
            <img src="./assets/books.jpg" class="responsive"> 
          </template>
          <!-- <div class="library-card-heading">
            Books
          </div> -->
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
        <vx-card class="overlay-card overflow-hidden library-content-cards" @click="showVideos">
          <template slot="no-body">
            <img src="./assets/videos.jpg" class="responsive">              
          </template>
          <!-- <div class="library-card-heading">
            Videos
          </div> -->
        </vx-card>
      </div>   
      <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
        <vx-card class="overlay-card overflow-hidden library-content-cards" @click="showPodcasts">
          <template slot="no-body">
            <img src="./assets/podcasts.jpg" class="responsive">              
          </template>
          <!-- <div class="library-card-heading">
            Podcasts
          </div> -->
        </vx-card>
      </div>         
    </div>     
    <library-resource-book
      :isCardActive="isBookViewActive"
      :genres="genres"
      @hideBackButton="isBackButtonHidden = true"
      @showBackButton="isBackButtonHidden = false"
    />
    <library-resource-video
      :isCardActive="isVideoViewActive"
      :genres="genres"
      @hideBackButton="isBackButtonHidden = true"
      @showBackButton="isBackButtonHidden = false"
    />
    <library-resource-podcast
      :isCardActive="isPodcastsViewActive"
      :genres="genres"
      @hideBackButton="isBackButtonHidden = true"
      @showBackButton="isBackButtonHidden = false"
    />
  </div>
</template>

<script>
  import vSelect from 'vue-select';
  import LibraryResourceBook from './LibraryResourceBook.vue';
  import LibraryResourceVideo from './LibraryResourceVideo.vue';
  import LibraryResourcePodcast from './LibraryResourcePodcast.vue';

  export default {
    data() {
      return {
        isResourceViewActive: true,
        isBookViewActive: false,
        isVideoViewActive: false,
        isPodcastsViewActive: false,
        isInfoHidden: true,
        genres: [],
        componentKey: 0,
        isBackButtonHidden: false
      }
    },
    components: {
      vSelect,
      LibraryResourceBook,
      LibraryResourceVideo,
      LibraryResourcePodcast,
    },
    computed: {
      
    },
    methods: {
      showBooks(){
        this.componentKey += 1;
        this.isBookViewActive = true;
        this.isResourceViewActive = false;
      },
      showVideos(){
        this.componentKey += 1;
        this.isVideoViewActive = true;
        this.isResourceViewActive = false;
      },
      showPodcasts(){
        this.componentKey += 1;
        this.isPodcastsViewActive = true;
        this.isResourceViewActive = false;
      },
      backToSelect(){
        this.isBookViewActive = false;
        this.isVideoViewActive = false;
        this.isPodcastsViewActive = false;
        this.isResourceViewActive = true;
      },                  
      getGenres(whenDone) {
        var self = this;
        var onSuccess = response => {
          self.genres = response.data.map((item) => { return { label: item.text, value: item.value } });
          if (whenDone && typeof whenDone == "function")
            whenDone();
        };

        self.$ajaxGet(self, "LibraryResource/ListGenres", onSuccess);
      },
    },   
    mounted() {
      var self = this;   
      self.getGenres();  
    },
  }

</script>

<style lang="scss">
.cropper-div {
  input[type="file"] {
    display: none;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 5px 0;
  }
  .header h2 {
    margin: 0;
  }
  .header a {
    text-decoration: none;
    color: black;
    
  }
  .cropper-area_tool {
    width: 60%;
  }
  .cropper-area_buttons {
    width: 100%;
  }
  .actions {
    margin-top: 1rem;
    display: flex;
  }
  textarea {
    width: 100%;
    height: 100px;
  }
  .preview-area {
    width: 307px;
  }
  .preview-area p {
    font-size: 1.25rem;
    margin: 0;
    margin-bottom: 1rem;
  }
  .preview-area p:last-of-type {
    margin-top: 1rem;
  }
  .preview {
    width: 100%;
    height: calc(372px * (9 / 16));
    overflow: hidden;
  }
  .crop-placeholder {
    width: 100%;
    height: 200px;
    background: #ccc;
  }
  .cropped-image img {
    max-width: 100%;
  }
}
</style>
